<script>
  let { title = "", children } = $props();
</script>

<div class="gray-box">
  {#if title}<h6 class="title">{title}</h6>{/if}
  {@render children()}
</div>

<style>
  .gray-box {
    background-color: var(--color-gray-shade-lightest);
    padding: var(--spacing-8) var(--spacing-9);
    margin-bottom: 64px;
    .title {
      margin: 0 0 44px 0;
      width: fit-content;
      background-color: white;
      padding: var(--spacing-2) var(--spacing-4);
      color: var(--color-gray-shade-darkest);
    }
  }
</style>
